import { TotalScoreSVG } from '../../assets/SVGAssets';

import decor1 from '../../assets/images/icon8.webp';

import './currentScore.css';
import Button from '../../components/button/Button';

export default function CurrentScore({
    score,
    questionCount,
    setQuestionComponent,
}) {
    return (
        <div className="totalScoreWrapper">
            <div className="timeOutBorders">
                <div className="timeOut-border left"></div>
                <div className="timeOut-border right"></div>
            </div>

            <div className="totalScoreTitle">
                <TotalScoreSVG />
            </div>

            <div className="totalScoreContent currentScoreContent">
                <h1>Current Score</h1>

                <p>keep going!</p>
                <Button
                    type={'squareButton resume'}
                    action={setQuestionComponent}
                    text="Resume Quiz"
                />
                <h2>
                    Your score is {score}/{questionCount} points
                </h2>
            </div>

            <img className="decor1" src={decor1} alt="decor" />
        </div>
    );
}
